var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c("CabeceraModalEditar", {
        attrs: {
          titulo: "Editar Cliente Proveedor de GPS",
          form: Object.values(_vm.pasos).find(function(x) {
            return x.step === _vm.pasoActivoIndex
          }).formState,
          inactivable: _vm.modificable,
          pasos: _vm.pasos,
          pasoActivoIndex: _vm.pasoActivoIndex,
          estadoEntidad: _vm.estadoEntidad,
          inactivoSinAsociacion: _vm.inactivoSinAsociacion,
          nombreEntidad: _vm.clienteProveedorSeleccionado
            ? _vm.clienteProveedorSeleccionado.nombre
            : "",
          entidad: "Cliente Proveedor de GPS"
        },
        on: {
          cerrar: _vm.handleCerrar,
          guardar: _vm.handleGuardar,
          inactivo: _vm.handleInactivo
        }
      }),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c(
        "ContenidoModal",
        [
          _c("ClienteProveedorForm", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.pasoActivoIndex === _vm.pasos.informacionGeneral.step,
                expression: "pasoActivoIndex === pasos.informacionGeneral.step"
              }
            ],
            attrs: {
              nuncaEdit: true,
              clienteProveedorSeleccionado: _vm.lstClienteProveedor.data
            },
            on: { change: _vm.handleFormChange }
          }),
          _c("ProveedorGrid", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.pasoActivoIndex ===
                  _vm.pasos.asociarClienteProveedor.step,
                expression:
                  "pasoActivoIndex === pasos.asociarClienteProveedor.step"
              }
            ],
            attrs: {
              clienteProveedorSeleccionado: _vm.lstClienteProveedor.data,
              proveedores: _vm.lstProveedores,
              esEditar: true,
              idCliente: _vm.clienteProveedorSeleccionado
                ? _vm.clienteProveedorSeleccionado.id
                : 0
            },
            on: { change: _vm.handleProveedoresChange }
          })
        ],
        1
      ),
      _c("Confirmation", {
        attrs: {
          show: _vm.dialogConfirmacionClose,
          titulo: _vm.$t("mensajes.mensajesAbandono.editar.titulo"),
          mensaje: _vm.$t("mensajes.mensajesAbandono.editar.mensaje"),
          textoBtnSi: _vm.$t("mensajes.mensajesAbandono.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.mensajesAbandono.editar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallbackConfirm($event, false)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }